
export enum CommodityConditionTypeCd {
	NEW = 'New',
	USED = 'Used'}

